import * as ko from 'knockout';
import * as _ from 'underscore';

import { BlockUI } from 'Core/Common/BlockUi';
import { Notifier } from 'Core/Common/Notifier';

import { ScreenTypes } from 'Core/Common/Enums/ScreenTypes';

import { IControl } from 'Core/Controls/IControl';

import { LabelPositions } from 'Core/Screens/DesignScreen/ControlEditor/Enums/LabelPositions';

import { BaseControlEditor, EVENTS as BASE_CONTROL_EDITOR_EVENTS } from './BaseControlEditor';

import { ILabelPosition } from './ControlEditor';

import { EntitiesStore } from 'Core/Screens/DesignScreen/ControlEditor/Stores/EntitiesStore';
import { EntityModel } from 'Core/Screens/DesignScreen/ControlEditor/Models/EntityModel';

import { FieldModel } from '../Models/FieldModel';
import {IconManager} from "Core/Components/IconManager/IconManager";
import Template from 'Core/Screens/DesignScreen/ControlEditor/Templates/AIWorkflowControlEditor.html';
import { GlobalManager, GLOBALS } from 'Core/GlobalManager/GlobalManager';
import { FIELD_TYPES } from '../../../../Constant';
import { GENERAL_PROPERTIES } from 'Core/GeneralProperties/Managers/Constants';
import { AttachedFieldModel } from 'Core/Controls/BaseControl/Models/AttachedFieldModel';
import {IconModel} from "Core/Controls/BaseControl/Models/IconModel";
import { DesignScreen } from 'Core/Screens/DesignScreen/DesignScreen';

ko.templates['Core/Screens/DesignScreen/ControlEditor/Templates/AIWorkflowControlEditor'] =
    Template;

export const EVENTS = {
    ENTITY_SELECTED: 'ENTITY_SELECTED',
    FIELD_SELECTED: 'FIELD_SELECTED',
};

export class AIWorkflowControlEditor extends BaseControlEditor {
    private _fields: KnockoutObservableArray<FieldModel>;
    private _selectedField: KnockoutObservable<FieldModel>;
    protected _selectedEntity: KnockoutObservable<EntityModel>;
    private _iconModel = IconModel;
    private _icon: KnockoutObservable<IconModel>;
    constructor(control: IControl) {
        super(control);
        this._icon = ko.observable(control.GetIcon());
        this.InitEditControlData(control);
        this.BindEvents();
    }

    GetTemplateName(): string {
        return 'Core/Screens/DesignScreen/ControlEditor/Templates/AIWorkflowControlEditor';
    }

    AfterRender(el: HTMLElement) {
        const container = el[0];
        super.AfterRender(container);

        BlockUI.Block();

        this.LoadData()
            .then((entities) => this.PopulateEntities(entities))
            .always(() => BlockUI.Unblock());
    }

    LoadData() {
        return EntitiesStore.Get({
            EntityId: this.GetSubjectEntityId(),
            TableTypeId: this.GetSubjectTableTypeId(),
        });
    }

    Save(): void {
        const validationError = this.Validate();
        if (validationError) {
            new Notifier().Warning(validationError);
            return;
        }

        const controlEditorModel = this.GetControlEditorModel();

        this.Trigger(BASE_CONTROL_EDITOR_EVENTS.CONTROL_SAVED, {
            UpdateControlModel: controlEditorModel,
        });

        this.Close();
    }

    Validate() {
        const validationError = super.Validate();
        if (validationError) {
            return validationError;
        }

        if (!this._selectedField()) {
            this.IsValid(false);
            return 'Please, select field';
        }
    }

    GetControlEditorModel() {
        const desktopLanguage = GlobalManager.Instance.GetGlobal(GLOBALS.DESKTOP_LANGUAGE);
        const controlEditorModel = super.GetControlEditorModel();

        const selectedEntity = this._selectedEntity();
        controlEditorModel.EntityId = selectedEntity.EntityId;
        controlEditorModel.EntityName = selectedEntity.EntityName;

        const selectedField = this._selectedField();
        controlEditorModel.FieldId = selectedField.FieldId;
        controlEditorModel.FieldName = selectedField.FieldName;
        controlEditorModel.FieldNameTranslation = selectedField.FieldNameTranslation;
        controlEditorModel.ValTableId = selectedField.ValTableId;
        controlEditorModel.ValFieldId = selectedField.ValFieldId;
        controlEditorModel.Icon = this._icon();
        controlEditorModel.UseFieldName = this.UseFieldName();
        if (controlEditorModel.UseFieldName) {
            controlEditorModel.Name = selectedField.FieldName;
        } else {
            _.each(controlEditorModel.NameTranslations, (translation) => {
                if (translation.Selected || desktopLanguage == translation.Language.ShortName) {
                    translation.Selected = true;
                }
            });
        }
        return controlEditorModel;
    }

    FieldSelectorAfterRender(option, item) {
        ko.applyBindingsToNode(
            option,
            {
                // has removed the functionality of the "disabled/enabled of Fields"
                enableAttr: true,
                css: {
                    disabled: false,
                },
            },
            item
        );
    }

    protected InitEditControlData(control: IControl) {
        super.InitEditControlData(control);

        this.InitEntities();
    }

    protected BindEvents() {
        this._selectedEntity.subscribe((selectedEntity) => {
            if (this._selectedEntity()) {
                this.Trigger(EVENTS.ENTITY_SELECTED, selectedEntity);
            }
        });
    }

    OnSelectField(selectedField) {
        this.Trigger(EVENTS.FIELD_SELECTED, selectedField);
    }
    private InitEntities() {
        this._selectedEntity = ko.observable(null);

        this._fields = ko.observableArray([]);
        this._selectedField = ko.observable(null);
    }

    PopulateEntities(entities: EntityModel[]) {
        if(entities.length == 0){
            return;
        }

        entities[0].Fields =  entities[0].Fields.filter((field) => field.FieldTypeName === FIELD_TYPES.Memo)
        this._selectedEntity(entities[0]);
        this._fields(entities[0].Fields);
    }

        OpenIconManager() {
            const screen = this.Control.GetForm().GetScreen() as DesignScreen;
            const icons = screen.DesignModel.Icons;
    
            let iconManager = new IconManager(icons);
            iconManager.Show();
    
            iconManager.On('ICON_SELECTED', this, (eventArgs) => {
                this._icon(eventArgs.data.Icon);
            });
        }
    
        get Icon() {
            return this._icon();
        }
}
